import React, { useState } from "react";
import Textfield from "@atlaskit/textfield";
import JSONPathTest from "../../common/components/JSONPathTest";
const JsonPathPage = () => {
  const [path, setPath] = useState("");
  const changePath = (e) => {
    setPath(e.target.value);
  };
  return (
    <div className="ihub-public-main">
      <h3>JSON Path Tester</h3>
      <Textfield compact="true" name="path" value={path} label="JSON Path" onChange={changePath} />
      <JSONPathTest path={path} />
    </div>
  );
};

export default JsonPathPage;
